module.exports = __webpack_public_path__ + "img/indicators-banner@3x.54fa2500.png";